/** Early dev placeholder products — hidden on storefront until removed from DB (see backend remove-dev-seed-products). */
export const DEV_SEED_PRODUCT_NAMES = new Set([
  'Wireless Bluetooth Headphones',
  'Smart Fitness Watch',
  'Designer Sunglasses',
  'Premium Coffee Maker',
  'Yoga Mat Premium',
  'Skincare Set',
  'Board Game Collection',
  'Running Shoes',
  'Portable Speaker',
  'DIY Tool Kit Set',
  'Gaming Controller Pro',
  'Video Game Collection',
  'Strategy Board Games Set',
  'External Hard Drive 2TB',
  'USB Flash Drive 128GB',
  'Phone Repair Tool Kit',
  'Screwdriver Set Professional',
  'Arduino Starter Kit',
]);

export function isDevSeedProduct(product) {
  const name = String(product?.name || '').trim();
  return name && DEV_SEED_PRODUCT_NAMES.has(name);
}
